// Import Bootstrap JS (needed for navbar toggler, collapse, etc.)
import * as bootstrap from 'bootstrap';

// Make Bootstrap available globally for inline scripts and debugging
window.bootstrap = bootstrap;

// Import your custom CSS
import '../css/main.css';
import '../css/sass/styles.sass';

// Import your custom JS files
import './reda.js';
import './menu.js';
import './nch.js';
import './productutils.js';
import './cart-accs.js';
import './csas.js';
import './mktree.js';
import './shell.js';
import './slider.js';
import './spinner.js';


